import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import { Button} from 'rmwc/Button';
import { Link } from 'react-router-dom'
import {TextField} from 'rmwc/TextField';
import SerializeForm from 'form-serialize'
import {Card} from 'rmwc/Card';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import ReactExport from "react-data-export";
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'	


class TPOReportDownloadCountAdmin extends Component {
	constructor(props) {
	    super(props)
	    this.state = {
	    	status: '',
	      	errorMsg: '',
	      	downloadDisable:true,
	      	exportMaxNumRecords: 10000,
	      	testCycleId: 6,
	      	reportDownloadDisable: false,
	      	data: {        
	      		start: 1,
	        	end: 10000,
	        	exportData:[],   
	        	year:2019,
	        	rollnumber:'',
            userId: '',
            selectedOption: 'institution',
            reportId: ''
	      	}
	    }
  	}

	onReportCountChangeForExport = evt => {
	    const data = Object.assign({}, this.state.data);
	    data[evt.target.name] = evt.target.value;
	    data.end = parseInt(data.start)+parseInt(this.state.exportMaxNumRecords)-1
	    this.setState({data, downloadDisable:true});
	}

	handleExportUserData = e => {
	    e.preventDefault()
	    let data = Object.assign({}, this.state.data)
	    if(!this.state.downloadDisable){
	      	this.setState({downloadDisable: true})
	    }
	    if(data.start > 0){
	      	api.exportTPOReportDownloadData(this.props.user.accessToken, data.start, this.state.testCycleId)
	      	.then((result) => {
	        	const { status, errors} = result
	          	if (status === 'success') {
		            data.exportData = result.data
		            this.setState({data:data, errorMsg:'', downloadDisable:false})
		        }
	        })
	        .catch((err) => {
	          	this.setState({ errorMsg: 'Error in Fetching Details', downloadDisable:true })
	        })
	    }
	    else{
	      this.setState({errorMsg: 'Please provide valid id for export'})
	    }
    }

    componentDidMount() {}

    onInputChange = evt => {
    	const data = Object.assign({}, this.state.data);
    	data[evt.target.name] = evt.target.value;
    	this.setState({data});
  	};


  	fetchTPOReportForUser = (e) => {
        
    	e.preventDefault()
    	this.setState({reportDownloadDisable: true})
      let report_id = this.state.data.reportId
      api.downloadAdminTPOReport(this.props.user.accessToken, this.state.data.reportId)
      .then((result) => {
         if (result instanceof Blob){
          this.setState({ errorMsg: '', reportDownloadDisable: false })
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${report_id}_report.pdf`);
          document.body.appendChild(link);
          link.click();
          
        }
        else{
          this.setState({ reportDownloadDisable: false, errorMsg: 'Unable to download reports. Please contact Administrator' })
          //this.props.onLoadingState(false, 'Unable to download reports. Please contact Administrator')
        }      
      }).catch((err) => {
          this.setState({ reportDownloadDisable: false, errorMsg: 'Unable to downlod reports. Plaase contact Admin' })
          //this.props.onLoadingState(false, 'Unable to download reports. Please contact Admin')
      })
   

    
  	}

    handleOptionChange = (e) => {
      let data = Object.assign({}, this.state.data)
      data.selectedOption = e.target.value
      this.setState({data: data})
    }

    fetchTPOReportForInstitution = (e) => {
        
      e.preventDefault()
      this.setState({reportDownloadDisable: true})
      api.downloadInstGropuReportAdmin(this.props.user.accessToken, this.state.data.selectedOption, this.state.data.year, this.state.data.userId)
      .then((result) => {
         if (result instanceof Blob){
          this.setState({ errorMsg: '', reportDownloadDisable: false })
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'tporeportforgroup.pdf');
          document.body.appendChild(link);
          link.click();
          
        }
        else{
          this.setState({ reportDownloadDisable: false, errorMsg: 'Unable to download reports. Please contact Administrator' })
          //this.props.onLoadingState(false, 'Unable to download reports. Please contact Administrator')
        }      
      }).catch((err) => {
          this.setState({ reportDownloadDisable: false, errorMsg: 'Unable to downlod reports. Plaase contact Admin' })
          //this.props.onLoadingState(false, 'Unable to download reports. Please contact Admin')
      })
    }

    render() {
    	const ExcelFile = ReactExport.ExcelFile;
      	const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
      	const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
      	let excelComponent = (
      		<div>
	      		<ExcelFile element = {<Button disabled={this.state.downloadDisable}>Download</Button>} >
	      			<ExcelSheet data={this.state.data.exportData} name="userexport">
                <ExcelColumn label="report_id" value="id"/>
	      				<ExcelColumn label="user_id" value="user_id"/>
	      				<ExcelColumn label="rollnumber" value="rollnumber"/>
	      				<ExcelColumn label="report_download_count" value="report_download_count"/>
                <ExcelColumn label="test_cycle_id" value="test_cycle_id" />
	      			</ExcelSheet>
	      		</ExcelFile>
      		</div>
      	)

      	let reportCompnent = (<Grid>
      			
      			<GridCell span="12">
      				<Typography use="headline5">Download Specific Report</Typography>
            </GridCell>
            <GridCell span="3">
            	<TextField  className='text_input' type="number" label="Report Id" autoComplete="off" name="reportId" onChange={this.onInputChange} value={this.state.data.reportId}/>
            </GridCell>
            
      			<GridCell span="6"/>
      			<GridCell span="2"/>
      			<GridCell span="3">
      				<Button disabled={this.state.reportDownloadDisable} onClick={((e) => this.fetchTPOReportForUser(e))}>Download</Button>
      			</GridCell>
      			<GridCell span="7"/>

      			</Grid>
      		)

      let groupReportComponent;
      groupReportComponent = (
        <Grid>
          <GridCell span="12">
            <Typography use="headline5">Download Group Institution Report</Typography>
          </GridCell>
          <GridCell span="4">
              <TextField  className='text_input'  label="User Id" autoComplete="off" name="userId" onChange={this.onInputChange} value={this.state.data.userId}/>
            </GridCell>
            <GridCell span="4">
              <TextField  className='text_input' type="number" disable label="Year" autoComplete="off" name="year" onChange={this.onInputChange} value={this.state.data.year}/>
            </GridCell>
            <GridCell span="4">
              <Select 
                onChange={this.handleOptionChange} 
                value={this.state.data.selectedOption}
                className="admin-reg-filter-section" 
              >
                <option value="institution">Institution</option>
                <option value="group">Group</option>
              </Select>
            </GridCell>
            <GridCell span="3">
              <Button disabled={this.state.reportDownloadDisable} onClick={((e) => this.fetchTPOReportForInstitution(e))}>Download</Button>
            </GridCell>
        </Grid>
      )


    	return (
    		<div><Grid>
          		<GridCell span="12">
          			<Card style={{padding: '25px'}}>
                		<Typography use="headline5">TPO Report Details</Typography>
              		</Card>
              	</GridCell>
              	<TextField  className='text_input' type="number" label="Id From" autoComplete="off" name="start" onChange={this.onReportCountChangeForExport} value={this.state.data.start}/>
              	<TextField  className='text_input' type="number" disable label="To" autoComplete="off" name="start"  value={this.state.data.end}/>
              	<Button onClick={this.handleExportUserData}>Export</Button>
              	{excelComponent}
         </Grid>
         		{reportCompnent}
            {groupReportComponent}
         		<StatusMessage error_msg = {this.state.errorMsg}/>
         </div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  	return {
    	user,
    	admin
  	}
}

function mapDispatchToProps() {
  	return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPOReportDownloadCountAdmin);


// WEBPACK FOOTER //
// ./src/views/admin/TPOReportDownloadCountAdmin.jsx